export default "__VITE_ASSET__sKjM8zie__"